import Icon from 'vue-awesome/components/Icon'

Icon.register({
  invert_colors_two_tone: {
    paths: [
      {
        opacity: '.3',
        d: 'M6 13.59c0 1.6.62 3.1 1.76 4.24A5.928 5.928 0 0012 19.59V5.1L7.76 9.35A5.928 5.928 0 006 13.59z'
      },
      {
        d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58s4.1-.78 5.66-2.34c3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76A5.945 5.945 0 016 13.59c0-1.6.62-3.11 1.76-4.24L12 5.1v14.49z'
      }
    ],
    width: '24',
    height: '24'
  }
})
